import { Row, Col, Card, Button, Input, Form, Select, Radio, InputNumber } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import { useNavigate } from "react-router";
import apiPath from "../../../constants/apiPath";
import DescriptionEditor from '../../../components/DescriptionEditor'
import SingleImageUpload from "../../../components/SingleImageUpload";
import MultipleImageUpload from "../../../components/MultipleImageUpload";
import { Link } from "react-router-dom";

function Add() {

    const generateRandomSKU = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let sku = '';

        const randomNum = Math.floor(Math.random() * (15 - 4 + 1)) + 4;

        for (let i = 0; i < randomNum; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            sku += characters.charAt(randomIndex);
        }

        return sku;
    }

    const sectionName = "Product";
    const routeName = "product/catalogue";

    const api = {
        addEdit: apiPath.addEditProduct,
        // brand: apiPath.listBrand,
        category: apiPath.categoryList
    }

    const [form] = Form.useForm();
    const { request } = useRequest()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [editorValue, setEditorValue] = useState('');
    const FileType = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/gif"]
    const [image, setImage] = useState([]);
    const [makeList, setMakeList] = useState([])
    const [typeList, setTypeList] = useState([])
    const [modelList, setModalList] = useState([])
    const [variantList, setVariantList] = useState([])
    const [categoryList, setCategoryList] = useState([])
    const [years, setYears] = useState([]);
    const [multipleImage, setMultipleImage] = useState([]);
    const [multipleFile, setMultipleFile] = useState([]);
    const [skuu, setSku] = useState(() => generateRandomSKU());

    const handleEditorChange = (data) => {
        setEditorValue(data);
    }

    const handleImage = (data) => {
        setImage(data);
    }

    const handleMultipleImage = (data) => {
        setMultipleImage(data);
    }

    /* const getBrandList = () => {
        request({
            url: `${api.brand}?page=1&limit=1000&status=${true}`,
            method: 'GET',
            onSuccess: (data) => {
                console.log(data);
                setBrandList(data.data.list.docs);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }; */

    const getCategoryList = () => {
        request({
            url: api.category + "/" + 'product',
            method: 'GET',
            onSuccess: (data) => {
                setCategoryList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };

    const getTypeList = () => {
        request({
            url: '/common/type',
            method: 'GET',
            onSuccess: (data) => {
                setTypeList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const getMakeList = (id) => {
        request({
            url: `/common/make?type=${id}`,
            method: 'GET',
            onSuccess: (data) => {
                setMakeList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const getModalList = (id) => {
        request({
            url: `/common/model/${id}`,
            method: 'GET',
            onSuccess: (data) => {
                setModalList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const getVariantList = (id) => {
        request({
            url: `/common/variant/${id}`,
            method: 'GET',
            onSuccess: (data) => {
                setVariantList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const onCreate = (values) => {
        if (editorValue.trim() === '<p></p>' || editorValue.trim() === "") return ShowToast('Please Enter Description', Severty.ERROR)
        const { name, part_number, /* brand_id, */ category_id, is_featured, type_id, make_id, model_id, variant_id, price, year_model, sku } = values
        const payload = {};
        payload.name = name;
        payload.price = price;
        payload.part_number = part_number;
        payload.added_by = "Admin";
        payload.category_id = category_id;
        payload.thumbnail = image.length > 0 ? image[0].url : '';
        payload.description = editorValue;
        payload.is_featured = is_featured;
        payload.type_id = type_id;
        payload.make_id = make_id;
        payload.model_id = model_id;
        payload.variant_id = variant_id;
        payload.year_model = year_model;
        payload.sku = sku || skuu;
        payload.image = multipleImage.length > 0 ? multipleImage.map((item) => item.url) : '';
        setLoading(true)
        request({
            url: api.addEdit,
            method: 'POST',
            data: payload,
            onSuccess: (data) => {
                setLoading(false)
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS)
                    navigate(`/pimptup-admin/${routeName}`);
                } else {
                    ShowToast(data.message, Severty.ERROR)
                }
            },
            onError: (error) => {
                ShowToast(error.response.data.message, Severty.ERROR)
                setLoading(false)
            },
        })
    };

    useEffect(() => {
        let yearModels = [];
        for (let i = 1990; i <= new Date().getFullYear(); i++) {
            yearModels.push(i);
        }
        setYears(yearModels);
    }, []);

    useEffect(() => {
        getCategoryList();
        getTypeList()
    }, [])

    return (
        <>
            <Card className="cardHeader" title={"Add " + sectionName}>
                <Form initialValues={{ sku: skuu }} className="edit-page-wrap colPadding" form={form} onFinish={onCreate} autoComplete="off" layout="verticle" name="catalogue_form">
                    <Row gutter={[24, 0]}>
                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item
                                normalize={value => value.trimStart()} label="Name" name="name"
                                rules={[{ required: true, message: "Missing the name!" },
                                { max: 30, message: "Name must contain minimum 4 and maximum 30 characters " },
                                { min: 4, message: "Name must contain minimum 4 and maximum 30 characters " }
                                ]}>
                                <Input autoComplete="off" placeholder="Enter Product Name" />
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item
                                normalize={value => value.trimStart()} label="Sku" name="sku"
                                rules={[{ required: true, message: "Missing the sku!" },
                                { max: 16, message: "Name must contain minimum 4 and maximum 15 characters " },
                                { min: 4, message: "Name must contain minimum 4 and maximum 15 characters " }
                                ]}>
                                <Input defaultValue={skuu} onChange={(e) => setSku(e.target.value)} autoComplete="off" placeholder="Enter Product SKU" />
                            </Form.Item>
                        </Col>
                        {/* </Row>

                    <Row gutter={[24, 0]}> */}
                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="category-elt"
                                name="category_id"
                                label="Select Category"
                                rules={[{ required: true, message: 'Missing Category Selection' }]}
                            >

                                <Select placeholder="Select Category">
                                    {categoryList && categoryList.length > 0 ? categoryList.map((item, index) => (
                                        <option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </option>
                                    )) : null}
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="brand-elt"
                                name="brand_id"
                                label="Select Brand"
                                rules={[{ required: true, message: 'Missing Brand Selection' }]}
                            >
                                <Select placeholder="Select Brand">
                                    {brandList && brandList.length > 0 ? brandList.map((item, index) => (
                                        <option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </option>
                                    )) : null}
                                </Select>
                            </Form.Item>
                        </Col> */}

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="type-elt"
                                name="type_id"
                                label="Select Type"
                                rules={[{ required: true, message: 'Missing Type Selection' }]}
                            >
                                <Select
                                    placeholder="Select Type"
                                    onChange={(type) => getMakeList(type)}
                                >
                                    {typeList.map((item, index) => (
                                        <Select.Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="make-elt"
                                name="make_id"
                                label="Select Make"
                                rules={[{ required: true, message: 'Missing Make Selection' }]}
                            >
                                <Select
                                    placeholder="Select Make"
                                    onChange={(make) => getModalList(make)}
                                >
                                    {makeList.map((item, index) => (
                                        <Select.Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="model-elt"
                                name="model_id"
                                label="Select Model"
                                rules={[{ required: true, message: 'Missing Model Selection' }]}
                            >
                                <Select
                                    onChange={(model) => getVariantList(model)}
                                    placeholder="Select Model">
                                    {modelList.map((item, index) => (
                                        <Select.Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="variant-elt"
                                name="variant_id"
                                label="Select Variant"
                                rules={[{ required: true, message: 'Missing Variant Selection' }]}
                            >
                                <Select placeholder="Select Variant">
                                    {variantList.map((item, index) => (
                                        <Select.Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="variant-elt"
                                name="year_model"
                                label="Select Model Year"
                                rules={[{ required: true, message: 'Missing Model Year Selection' }]}
                            >
                                <Select placeholder="Select Model Year">
                                    {years.map((item, index) => (
                                        <Select.Option key={index} value={item}>
                                            <span className="cap">{item}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item normalize={value => value.trimStart()} label="Part Number"
                                name="part_number"
                                rules={[{ required: true, message: "Missing part number!" },
                                { max: 15, message: "Part Number contain minimum 4 and maximum 15 characters " },
                                { min: 4, message: "Part Number contain minimum 4 and maximum 15 characters " }]}
                            >
                                <Input autoComplete="off" placeholder="Enter Part Number" />
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item
                                label="Base price"
                                name="price"
                                rules={[
                                    { required: true, message: "Missing the price!" },
                                    // { max: 7, message: "Price contain maximum 7 digits " },
                                ]}>
                                <InputNumber type="number" maxLength={10} autoComplete="off" placeholder="Enter Base price" />
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item label="Mark as Featured" name="is_featured">
                                <Radio.Group>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        {/* </Row>

                    <Row gutter={[24, 0]}> */}
                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (value !== undefined && value?.length > 0) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Missing Image!'));
                                        },
                                    }
                                ]}
                                label="Upload Thumbnail" name="image">
                                <SingleImageUpload value={image} fileType={FileType} imageType={'product'} btnName={'Thumbnail'} onChange={(data) => handleImage(data)} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="Upload Other Image" name="image">
                                <div className="mt-1 otherImages">
                                    <MultipleImageUpload
                                        fileType={FileType}
                                        imageType={'product'}
                                        btnName={'Image'}
                                        onChange={(data) => handleMultipleImage(data)}
                                    />
                                </div>
                            </Form.Item>
                        </Col>

                        <Col md={24}>
                            <Form.Item label="Description" name="description">
                                <DescriptionEditor value={editorValue} placeholder="Enter Product Description" onChange={(data) => handleEditorChange(data)} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item className="btn-row float-right mb-0">
                        <Link className="ant-btn ant-btn-primary" to={`/pimptup-admin/${routeName}`}>Back</Link>
                        <Button type="primary" loading={loading} htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Card>
        </>
    )
}


export default Add;
